/**
 * Entitlements Types
 *
 * Re-exports types from @erebus/api-types with convenient aliases.
 * These types are AUTO-GENERATED from backend Swagger docs.
 *
 * Source: apps/backend/pkg/entitlements/handler.go (Swagger annotations)
 * Generated: packages/api-types/src/generated.ts
 */

import type { definitions } from '@erebus/api-types'
import type { TierValue } from './enums'
import { Module } from './enums'

// =============================================================================
// API TYPES (Re-exported from @erebus/api-types)
// =============================================================================

/**
 * Response from GET /entitlements/clients/:clientId/modules
 *
 * Contains complete entitlement data for a client (tier, modules, add-ons, denials)
 */
export type ModulesResponse = definitions['pkg_entitlements.ModulesResponse']

/**
 * Response from GET /entitlements/clients/tiers
 *
 * Paginated list of all client tier assignments (admin only)
 */
export type TierListResponse = definitions['pkg_entitlements.TierListResponse']

/**
 * Individual client tier DTO
 */
export type ClientTierDTO = definitions['pkg_entitlements.ClientTierDTO']

/**
 * Request body for granting or denying a module
 *
 * POST /entitlements/clients/:clientId/modules/:moduleKey
 * POST /entitlements/clients/:clientId/modules/:moduleKey/deny
 */
export type ModuleActionRequest = definitions['pkg_entitlements.ModuleActionRequest']

/**
 * Request body for changing a client's tier
 *
 * PATCH /entitlements/clients/:clientId/tier
 */
export type PatchTierRequest = definitions['pkg_entitlements.PatchTierRequest']

/**
 * Request body for bulk entitlements endpoint
 *
 * POST /entitlements/clients/bulk
 */
export type BulkEntitlementsRequest = definitions['pkg_entitlements.BulkEntitlementsRequest']

/**
 * Response from POST /entitlements/clients/bulk
 *
 * Contains entitlements for multiple clients (admin only)
 */
export type BulkEntitlementsResponse = definitions['pkg_entitlements.BulkEntitlementsResponse']

// =============================================================================
// DOMAIN TYPES (Frontend-specific convenience types)
// =============================================================================

/**
 * Client entitlements (computed result) - domain model
 *
 * This represents the final computed entitlements for a client after
 * applying tier base modules + add-ons - denials.
 *
 * Converted from API snake_case to camelCase for better TypeScript ergonomics.
 */
export interface ClientEntitlements {
  clientId: number
  tier: TierValue
  modules: Module[]
  addOns: Module[]
  denials: Module[]
}

/**
 * Convert API response to domain model
 *
 * Maps snake_case API response to camelCase domain model.
 */
export function toClientEntitlements(response: ModulesResponse): ClientEntitlements {
  return {
    clientId: response.client_id || 0,
    tier: (response.tier as TierValue) || 'core',
    modules: (response.modules as Module[]) || [],
    addOns: (response.add_ons as Module[]) || [],
    denials: (response.denials as Module[]) || []
  }
}

/**
 * Pagination parameters for list endpoints
 */
export interface PaginationParams {
  limit?: number
  offset?: number
}
